import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import axios from 'axios'

export const RelatedInvOpts = createAsyncThunk('inv-related-opts', async (_, thunkAPI) => {
  try {
    const response = await axios.get('/api/rep/inv-related-opts')
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const StudentPaymentRep = createAsyncThunk('std-payment', async (data: {}, thunkAPI) => {
  try {
    const res = await axios.post('/api/rep/student-payments', data)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const PrintStdPayments = createAsyncThunk(
  'std-payment-print',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.post('/api/rep/std-payment-print', params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const StudentPaymentExcel = createAsyncThunk(
  'std-payment-excel',
  async (formData: FormData) => {
    const response = await axios.post('/api/rep/std-payment-excel', formData, {
      responseType: 'blob', // ← MUST be here (3rd argument)
    })

    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    })

    const url = window.URL.createObjectURL(blob)

    const link = document.createElement('a')
    link.href = url
    link.download = 'StudentPayments.xlsx'
    document.body.appendChild(link)
    link.click()

    link.remove()
    window.URL.revokeObjectURL(url)
  }
)

export const OrgAy = createAsyncThunk('org-academic-years', async (_, thunkAPI) => {
  try {
    const response = await axios.get('/api/rep/org-academic-years')
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const orgPaymentRep = createAsyncThunk('org-payment', async (data: {}, thunkAPI) => {
  try {
    const res = await axios.post('/api/rep/org-payments', data)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const PrintOrgPayments = createAsyncThunk(
  'org-payment-print',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.post('/api/rep/org-payment-print', params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const OrgPaymentExcel = createAsyncThunk('org-payment-excel', async (formData: FormData) => {
  const response = await axios.post('/api/rep/org-payment-excel', formData, {
    responseType: 'blob',
  })

  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })

  const url = window.URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = url
  link.download = 'OrganizationPayments.xlsx'
  document.body.appendChild(link)
  link.click()

  link.remove()
  window.URL.revokeObjectURL(url)
})

type ReportState = {}

const initialState: ReportState = {}

export const reportSlice = createSlice({
  name: 'report',
  initialState,
  reducers: {
    reset: () => initialState,
  },
})

export const {reset} = reportSlice.actions
export default reportSlice.reducer
